/**
 * @generated SignedSource<<269b69055861a60c9b538a02f44d6bfb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField$data = {
  readonly issueType: {
    readonly avatar: {
      readonly xsmall: string;
    } | null | undefined;
    readonly name: string;
  };
  readonly " $fragmentType": "summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField";
};
export type summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField$key = {
  readonly " $data"?: summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField$data;
  readonly " $fragmentSpreads": FragmentRefs<"summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "issueType",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "name"
            },
            "action": "THROW",
            "path": "issueType.name"
          },
          {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "kind": "ScalarField",
                  "name": "xsmall"
                },
                "action": "LOG",
                "path": "issueType.avatar.xsmall"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "issueType"
    }
  ],
  "type": "JiraIssueTypeField"
};

(node as any).hash = "9c2af22d7b07779fb498e0197b0b8a31";

export default node;
